import type { AnchorHTMLAttributes, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface CtaLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    tone?: 'primary' | 'secondary'
    size?: 'md' | 'lg'
}

// In-page call-to-action styled as a button. Brand rule: orange with navy text, or navy outline.
export const CtaLink: FC<CtaLinkProps> = ({
    tone = 'primary',
    size = 'lg',
    className,
    children,
    ...props
}): ReactNode => {
    return (
        <a
            className={cn(
                'inline-flex items-center justify-center gap-2 rounded-xl font-semibold transition duration-200 active:scale-[0.98]',
                size === 'lg' ? 'min-h-12 px-6 text-base' : 'min-h-11 px-4 text-sm',
                tone === 'primary'
                    ? 'bg-orange text-navy shadow-[0_8px_30px_-10px_rgb(255_138_61/0.6)] hover:bg-orange-light'
                    : 'border border-soft-white/20 bg-navy-700/60 text-soft-white hover:border-soft-white/40 hover:bg-navy-700',
                className
            )}
            {...props}
        >
            {children}
        </a>
    )
}
